import { ANGEL_NUDGE_STATUS, NUDGE_STATUS_OPTIONS } from '../constants';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import { Box, Toolbar, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { isBoolean, isEmpty } from 'lodash';
import React, { useMemo } from 'react';

const CustomButton = withStyles({
  label: {
    fontWeight: 600,
  },
})(Button);

const GroupToolbar = ({
  filterOption,
  angelNudgeStatuses,

  onFilterOptionChange,
  onResetFilterOps,

  nudgeStatuses,
}) => {
  const renderValue = (array, label, defaultLabel) => {
    let value = '';
    if (array.length === 0) value = defaultLabel;
    else if (array.length === 1) value = array[0];
    else value = `${label} (${array.length})`;

    return value;
  };

  const isEmptyFilterParams = useMemo(() => {
    const filterKeys = Object.keys(filterOption).filter(
      (key) => key !== 'isActive'
    );

    return filterKeys.every((key) =>
      isBoolean(filterOption[key])
        ? !filterOption[key]
        : isEmpty(filterOption[key])
    );
  }, [filterOption]);

  return (
    <Toolbar>
      <Box
        display="flex"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" gridGap={12}>
          <CustomSelectContainer
            isFullWidth
            filterValue={angelNudgeStatuses || []}
            data={ANGEL_NUDGE_STATUS}
            renderValue={renderValue(
              angelNudgeStatuses.map(
                (it) => ANGEL_NUDGE_STATUS.find((item) => item.key === it).value
              ),
              'Statuses',
              'All statuses'
            )}
            clearable={false}
            onChange={onFilterOptionChange('statuses')}
            labelSelectAll={'All statuses'}
            useSelectAll
            checkedAll={ANGEL_NUDGE_STATUS.length === angelNudgeStatuses.length}
          />
          <CustomSelectContainer
            isFullWidth
            filterValue={nudgeStatuses || []}
            data={NUDGE_STATUS_OPTIONS}
            renderValue={renderValue(
              nudgeStatuses.map(
                (it) =>
                  NUDGE_STATUS_OPTIONS.find((item) => item.key === it).value
              ),
              'Nudge Statuses',
              'All nudge statuses'
            )}
            clearable={false}
            onChange={onFilterOptionChange('nudgeStatus')}
            labelSelectAll={'All nudge statuses'}
            useSelectAll
            checkedAll={NUDGE_STATUS_OPTIONS.length === nudgeStatuses.length}
          />
        </Box>

        <CustomButton
          color="primary"
          disabled={isEmpty(nudgeStatuses) && isEmptyFilterParams}
          onClick={onResetFilterOps}
        >
          Reset
        </CustomButton>
      </Box>
    </Toolbar>
  );
};

export default GroupToolbar;
